const PLACEHOLDERS = new Set([
  '.',
  '-',
  '_',
  '..',
  '...',
  '카카오사용자',
  '이름 미설정',
  'unknown',
  'null',
]);

/** 카카오 `.` 등 자리표시자는 표시 이름으로 쓰지 않음 */
export function isUsableDisplayName(raw?: string | null): boolean {
  if (raw == null) return false;
  const name = raw.trim();
  if (name.length < 2 || name.length > 50) return false;
  if (PLACEHOLDERS.has(name) || PLACEHOLDERS.has(name.toLowerCase())) return false;
  return /[\p{L}\p{N}]/u.test(name);
}

export function needsDisplayNameSetup(raw?: string | null): boolean {
  return !isUsableDisplayName(raw);
}
